import { PharmaAddressDetails } from "@/redux/slice/location/interfaces/PharmaAddressDetails";
import checkTatAvailabilityApi from "@/redux/slice/cart/apis/checkTatAvailabilityApi";
import {
  addUpdateCartItem,
  appendOutOfStockSkus,
  markSkuListInStock,
  setGuestUserActionPayload,
  setIsCartUpdated,
  setServerCartErrorMessage,
  setUserActionPayload,
} from "@/redux/slice/cart/slice";
import { CartItem } from "@/redux/slice/cart/types/CartItem";
import { createCartItemFromProduct } from "./createCartItemFromProduct";

interface AddCartItemPayload {
  itemToAdd: CartItem;
  pharmaAddressDetails: PharmaAddressDetails;
  currentPatientId: string;
  dispatch: any;
}

export const addCartItem = ({ itemToAdd, pharmaAddressDetails, currentPatientId, dispatch }: AddCartItemPayload) => {
  if (currentPatientId) {
    dispatch(
      setUserActionPayload({
        medicineOrderCartLineItems: [
          {
            medicineSKU: itemToAdd.sku,
            quantity: itemToAdd.quantity,
          },
        ],
      })
    );
  } else {
    dispatch(
      setGuestUserActionPayload({
        medicineOrderCartLineItems: [
          {
            medicineSKU: itemToAdd.sku,
            quantity: itemToAdd.quantity,
          },
        ],
      })
    );
  }
};
